import { useTheme } from '@/hooks/useTheme';
import { useTranslation } from '@/hooks/useTranslation';
import { SimpleSelect } from '@/components/form/inputs/SimpleSelect';
import { cn } from '@/lib/utils';

type ThemeSelectorProps = {
  className?: string;
};

export function ThemeSelector({ className = '' }: ThemeSelectorProps) {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <label htmlFor="theme-select" className="eyebrow">
        {t('profile.preferences.themeLabel')}
      </label>
      <SimpleSelect
        id="theme-select"
        value={theme}
        onChange={(value) => value && setTheme(value as 'light' | 'dark')}
        options={[
          { value: 'light', label: t('common.themeLight') },
          { value: 'dark', label: t('common.themeDark') },
        ]}
        placeholder={t('common.chooseTheme')}
      />
    </div>
  );
}
